import { DATA_PAGINATION } from '@/types'
import { Soil } from '@/types/soil'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface SoilTableV2Props {
  data?: DATA_PAGINATION<Soil>
}

const SoilTableV2: FC<SoilTableV2Props> = ({ data }) => {
  return (
    <Stack flexGrow="1" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: '60px',
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  width: '300px',
                }}
              >
                Description
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ width: '60px' }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    width: '300px',
                  }}
                >
                  {row.description}
                </TableCell>
                <TableCell />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default SoilTableV2
